import stringSchema from "@/lib/utils/stringSchema";
import { z } from "zod";

const formSchema = z.object({
  name: stringSchema({ key: "Name", required: true }),
  status: z.boolean(),
  parent_id: z.string().optional().nullable(),
});

export default formSchema;
